// extracted by mini-css-extract-plugin
module.exports = {"modalCloseIcon":"HeaderBrowse_modalCloseIcon__rRySD"};